import FeatureFlagProps from '../../FeatureFlagProps';
import ShowFeatureComponent from './ShowFeature';
import ShowFeatureWithContext from './ShowFeatureWithContext';

const ShowFeature = (props: FeatureFlagProps) =>
  props.allFeatureFlags ? <ShowFeatureComponent {...props} /> : <ShowFeatureWithContext {...props} />;

export default ShowFeature;
